<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Webhooks">
          <WebhookList @showWebhook="showWebhook" @editWebhook="editWebhook" @newWebhook="newWebhook" ref="listagem" />
        </BaseCard>
      </v-col>
    </v-row>

    <div>
      <v-dialog v-model="show_webhook" max-width="1200px" width="90%" @click:outside="close">
        <WebhookDetail 
          :item="webhook" 
          @close="close" 
          @edit="editFromDetail" 
        />
      </v-dialog>
    </div>

    <div>
      <v-dialog v-model="show_form" max-width="1200px" width="90%" @click:outside="closeForm">
        <WebhookForm 
          :item="webhook" 
          :editing="editing"
          @close="closeForm" 
          @saved="webhookSaved" 
        />
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import WebhookList from '@/components/gerencial/webhook/list/List.vue'
import WebhookDetail from '@/components/gerencial/webhook/detail/Detail.vue'
import WebhookForm from '@/components/gerencial/webhook/form/Form.vue'
import WebhookApi from '@/services/webhook/webhook.service'

export default {
  name: 'Webhook',
  
  data() {
    return {
      webhook: {},
      show_webhook: false,
      show_form: false,
      editing: false,
      page: {
        title: 'Gerenciamento de Webhooks',
        icon: 'mdi-webhook',
      },
      breadcrumbs: [
        {
          text: 'Gerencial',
          disabled: true,
        },
        {
          text: 'Webhooks',
          disabled: true,
        },
      ],
    }
  },
  
  computed: {
    ...mapState('auth', ['empresaAtual']),
  },
  
  components: {
    WebhookList,
    WebhookDetail,
    WebhookForm,
  },
  
  methods: {
    async handleGet() {
      await this.$refs['listagem'].handleGetWebhooks()
    },
    
    async showWebhook(item) {
      try {
        const colaboradorId = this.empresaAtual?.colaborador_id
        if (!colaboradorId) {
          console.error('Colaborador não identificado')
          return
        }
        
        const webhook = await WebhookApi.get(colaboradorId, item.public_id)
        this.webhook = webhook
        this.show_webhook = true
      } catch (error) {
        console.error('Erro ao carregar webhook:', error)
        this.webhook = item
        this.show_webhook = true
      }
    },
    
    async editWebhook(item) {
      try {
        const colaboradorId = this.empresaAtual?.colaborador_id
        if (!colaboradorId) {
          console.error('Colaborador não identificado')
          return
        }
        
        const webhook = await WebhookApi.get(colaboradorId, item.public_id)
        this.webhook = webhook
        this.editing = true
        this.show_form = true
      } catch (error) {
        console.error('Erro ao carregar webhook para edição:', error)
        this.webhook = item
        this.editing = true
        this.show_form = true
      }
    },

    editFromDetail(item) {
      this.close()
      this.editWebhook(item)
    },
    
    newWebhook() {
      this.webhook = {}
      this.editing = false
      this.show_form = true
    },
    
    close() {
      this.webhook = {}
      this.show_webhook = false
    },
    
    closeForm() {
      this.webhook = {}
      this.show_form = false
      this.editing = false
    },
    
    webhookSaved() {
      this.closeForm()
      this.handleGet()
    },
  }
}
</script>

<style scoped>
.v-card-title .v-icon {
  margin-right: 16px;
}
</style>